'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {};
  },
  props: {
    btnGroup: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    bgColor: {
      type: String,
      default: '#FFFFFF'
    },
    selectIndex: {
      type: Number,
      default: 0
    },

    size: { //预留备用
      type: String,
      default: 'full'
    },
    disabled: { //预留备用
      type: Boolean,
      default: false
    }
  },
  computed: {
    wrapStyle: function wrapStyle() {
      var bgColor = this.bgColor;

      if (bgColor == '#ffffff' || bgColor == '#FFFFFF') {
        return {
          borderWidth: '2px',
          borderStyle: 'solid',
          borderColor: '#E5E5E8',
          overflow: 'hidden'
        };
      } else {
        return {
          borderWidth: '2px',
          borderStyle: 'solid',
          borderColor: 'rgba(255, 255, 255, 0.3)',
          overflow: 'hidden'
        };
      }
    },
    textStyle: function textStyle() {
      var bgColor = this.bgColor;

      if (bgColor == '#ffffff' || bgColor == '#FFFFFF') {
        return {
          color: '#8E969B'
        };
      } else {
        return {
          color: '#ffffff'
        };
      }
    },
    verticalLineStyle: function verticalLineStyle() {
      var bgColor = this.bgColor;

      if (bgColor == '#ffffff' || bgColor == '#FFFFFF') {
        return {
          borderRightWidth: '2px',
          borderRightStyle: 'solid',
          borderRightColor: '#E5E5E8'
        };
      } else {
        return {
          borderRightWidth: '2px',
          borderRightStyle: 'solid',
          borderRightColor: 'rgba(255, 255, 255, 0.3)'
        };
      }
    },
    textBtnStyle: function textBtnStyle() {
      var bgColor = this.bgColor;

      if (bgColor == '#ffffff' || bgColor == '#FFFFFF') {
        return {
          color: '#1E2E37',
          backgroundColor: '#E5E5E8'
        };
      } else {
        return {
          color: bgColor,
          backgroundColor: '#FFFFFF'
        };
      }
    }
  },
  methods: {
    onTextClicked: function onTextClicked(index) {
      // weex下不能完成事件委托
      this.selectIndex = index;
      this.$emit('dofGroupButtonClicked', index);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-button-group/index.vue
// module id = 305
// module chunks = 0 1